<template>
  <v-container>
    <center>
      <H1>Production Board 10/31/2022 Update</H1>
    </center>
    <!-- Production List View -->
          <v-row class="fill-height"
                 align="center"
                 justify="center">
            <v-col
            :md='6'
            :sm='10'
            >
            <div class='display-2 primary--text pb-5 hidden-md-and-up'> Scheduling and Production List View!</div>
              <v-img class='contain' src='img/listschedule.png' />
            </v-col>
            <v-col
              class='title'
              :md='6'
              :sm='12'
              >
              <div class='display-2 primary--text pb-5 hidden-sm-and-down' display: block>Scheduling and Production  List View!</div>

              <blockquote class="blockquote text-left">
                  Production Board improves upon its scheduling and production with all new ListView! ListView takes your production and scheduling screens and presents them in a familiar spreadsheet type display allowing you to choose how you view your scheduling and production.
              </blockquote>
            </v-col>
          </v-row>
          <v-row class="fill-height"
                 justify="center"
                 align="center">
                 <v-col
                    class="fill-height"
                    align="center"
                    :lg='4'
                    :md='4'
                    :sm='10'
                  >
                                <!-- Start of Cards -->
                   <v-card class="mx-auto fill-height">
                     <v-img class="white--text align-end"
                            height="200px"
                            src="img/listschedule.png">
                     </v-img>
                     <v-card-subtitle class="pb-0 primary--text subtitle-2">Scheduling</v-card-subtitle>
                     <v-card-text class="text--primary">
                       <div>Easily navigate to specific days on the calendar or jump between weeks at the push of a button. Schedule jobs and import just the same as before!</div>
                     </v-card-text>
                   </v-card>
                 </v-col>
            <v-col align="center"
            :lg='4'
            :md='4'
            :sm='10'
              >

              <v-card fill-height class="mx-auto fill-height">
                <v-img
                  contain
                  class="white--text align-end"
                  height="200px"
                  src="img/printlist.jpg">

                </v-img>
                <v-card-subtitle class="pb-0 subtitle-2 primary--text">Printable Production List</v-card-subtitle>
                <v-card-text class="text--primary">
                  <div>Print your open production list from list view including your production critical data.</div>
                </v-card-text>

              </v-card>
            </v-col>

            <v-col
              fill-height
              class='fill-height'
              align="center"
              :lg='4'
              :md='4'
              :sm='10'
            >
              <v-card fill-height class="mx-auto fill-height">
                <v-img

                  class="white--text align-end cover"
                       height="200px"
                       src="img\gif\flashing.gif">
                  <v-card-title></v-card-title>
                </v-img>
                <v-card-subtitle class="pb-0 primary--text subtitle-2">Filter and Sort List</v-card-subtitle>
                <v-card-text class="text--primary">
                  <div>Filter your Production ListView with the same parameters as you could with the board view creating custom list print outs.
                  </div>
                </v-card-text>

              </v-card>
            </v-col>

          </v-row>

</v-container>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
